import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

function AccessDeniedCard(props: any) {
  return (
    <Card
      sx={{
        minHeight: '72vh',
        borderRadius: 2,
        border: '1px solid',
        borderColor: '#fff',
        // bg gradient
        background: (theme: any) =>
          `linear-gradient(135deg, ${theme.palette.warning[50]} 0%, ${theme.palette.warning[100]} 100%)`,
        boxShadow: '0 10px 20px rgba(0,0,0,0.08), 0 6px 6px rgba(0,0,0,0.06)',
        transition: 'box-shadow 300ms ease',
        '&:hover': {
          boxShadow:
            '0 14px 28px rgba(0,0,0,0.10), 0 10px 10px rgba(0,0,0,0.08)'
        }
      }}>
      <CardContent>
        <Typography variant="h5" component="div" sx={{color: 'warning.dark'}}>
          Access Denied
        </Typography>
        <Typography variant="body2" sx={{color: 'warning.dark', mt: 2}}>
          {props?.message
            ? props?.message
            : `Your account is authenticated but lacks required AD group
          assignments. Please contact your administrator to configure your role
          permissions.`}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 3
          }}>
          <WarningAmberRoundedIcon
            sx={{
              color: 'warning.dark',
              width: '25rem',
              height: '10rem',
              maxWidth: '100%'
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default AccessDeniedCard;
